import {
  GetContext,
  MiddlewareHandler,
  MiddlewareHandlerArgs,
  genericCreateMiddleware,
} from '@lib/utils/redux/middleware/util';
import { State } from '../state';
import { Action, ActionCreator } from 'typescript-fsa';
import { store } from '../store';

type Context = void;

export type ClientHandlerArgs<TAction extends Action<unknown>> =
  MiddlewareHandlerArgs<State, Context, TAction>;

export type ClientMiddlewareHandler<
  C,
  TAction extends Action<unknown>
> = MiddlewareHandler<State, C, TAction>;

export type HandlerWithContext<TAction extends Action<unknown>> =
  ClientMiddlewareHandler<Context, TAction>;

/** A shorthand for the (likely) most commonly used type of middleware handler */
export type Handler<TPayload> = HandlerWithContext<Action<TPayload>>;

export type ActionHandler<TActionCreator extends ActionCreator<any>> =
  HandlerWithContext<ReturnType<TActionCreator>>;

/** Use this when payload type is not exported or obvious */
export const handle = <TActionCreator extends ActionCreator<any>>(
  ac: TActionCreator, handler: ActionHandler<TActionCreator>
) => handler;

export const createClientMiddleware = (getContext: GetContext<Context>) =>
  genericCreateMiddleware<State, Context, typeof store>(getContext);
